import React, { Component } from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { show } from 'redux-modal';
import Confirm from 'react-confirm-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ButtonDelete, ButtonEdit, ButtonDefault } from '../../../../../components/common/buttons/actions';
import { PublisherApi } from '../../../../../api';
import TemplatesModal from '../../../../../components/publisher/templates/TemplatesModal';
import { ButtonAdd } from '../../../../../components/common/buttons';

class WebsiteTemplateIndex extends Component {
  componentDidMount() {
    this.fetchResource();
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ data: nextProps.data });
  }

  handleDelete(c) {
    const { website, dispatch } = this.props;
    const data = { publisher_website_id: website.uuid };
    dispatch(PublisherApi.actions.templateDelete.post(c, (_error, success) => {
      if (success) dispatch(PublisherApi.actions.templates.get(data));
    }));
  }

  handleSetDefault(c, _r) {
    const { website, dispatch } = this.props;
    const data = { publisher_website_id: website.uuid };
    const params = {
      template: {
        default: true
      }
    };
    dispatch(PublisherApi.actions.templateUpdateDefault.post(c, params, (_error, success) => {
      if (success) dispatch(PublisherApi.actions.templates.get(data));
    }));
  }

  handleCreateTemplate() {
    const { dispatch, website } = this.props;

    dispatch(show('TemplateFormModal', {
      heading: 'New Template',
      formAction: 'Create',
      website
    }));
  }

  handleEdit(_c, r) {
    const { dispatch } = this.props;

    dispatch(show('TemplateFormModal', {
      template: r,
      heading: `Editing Template - ${r.name}`,
      formAction: 'Update'
    }));
  }

  fetchResource(params = {}) {
    const { website, dispatch } = this.props;
    const templates = get(this.props, 'templates.data', {});

    if (website.uuid && templates !== website.uuid) {
      const data = { ...params, publisher_website_id: website.uuid };
      dispatch(PublisherApi.actions.templates.get(data));
    }
  }

  renderActions(c, r) {
    return (
      <ul className='list-inline'>
        <li>
          <ButtonDefault
            onClick={this.handleSetDefault.bind(this, c, r)}
          />
        </li>
        <li>
          <ButtonEdit onClick={this.handleEdit.bind(this, c, r)} />
        </li>
        <li>
          <Confirm
            onConfirm={this.handleDelete.bind(this, c)}
            body='Are you sure you want to remove this template?'
            confirmText='Confirm Delete'
            title={`Deleting Template - ${r.name}`}
          >
            <div><ButtonDelete /></div>
          </Confirm>
        </li>
      </ul>
    );
  }

  renderName(c, r) {
    return (
      <a onClick={this.handleEdit.bind(this, c, r)}>{c}</a>
    );
  }

  render() {
    const { templates } = this.props;
    const { data } = templates || {};
    const iconCheck = <FontAwesomeIcon icon='check' />;

    return (
      <div className="ibox">
        <div className="ibox-title">
          <h5>Templates</h5>
        </div>
        <div className="ibox-content">
          <div className='m-b-sm text-left'>
            <ButtonAdd
              onClick={this.handleCreateTemplate.bind(this)}
              btnLabel='Add template'
            />
          </div>

          <BootstrapTable
            striped
            ref='templatesTable'
            data={data || []}
          >
            <TableHeaderColumn
              width="150"
              dataField="name"
              dataFormat={this.renderName.bind(this)}
            >
              Name
            </TableHeaderColumn>

            <TableHeaderColumn
              width="75"
              dataField="status"
              dataFormat={(c) => c}
            >
              Status
            </TableHeaderColumn>

            <TableHeaderColumn
              width="75"
              dataField="default"
              dataAlign="center"
              headerAlign="left"
              dataFormat={(c) => (c ? iconCheck : '')}
            >
              Default
            </TableHeaderColumn>

            <TableHeaderColumn
              width="100"
              dataField="device_type"
              dataFormat={(c) => c}
            >
              Device Type
            </TableHeaderColumn>


            <TableHeaderColumn
              width="75"
              dataField="slots"
              dataFormat={(c) => c}
            >
              Slots
            </TableHeaderColumn>

            <TableHeaderColumn
              width="100"
              dataField="custom_label"
              dataFormat={(c) => (c === 'custom' ? 'Yes' : 'No')}
            >
              Custom Label
            </TableHeaderColumn>

            <TableHeaderColumn
              isKey
              width="250"
              dataField="uuid"
              dataFormat={this.renderActions.bind(this)}
            >
              Actions
            </TableHeaderColumn>

          </BootstrapTable>
          <TemplatesModal />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { publisher, publisher: { websites } } = state;
  const { params: { websiteName } } = ownProps;
  const website = (websites.data.data || [])
    .filter((w) => w.slug === websiteName)[0] || {};

  return {
    templates: get(publisher, 'templates.data', {}),
    isLoading: get(publisher, 'templates.loading', {}),
    website
  };
};

export default connect(mapStateToProps)(WebsiteTemplateIndex);
